import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PRIMARY_DEMO_ACCOUNT_ID } from '../../config/demoAccounts';

const LandingNav: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`landing-nav ${scrolled ? 'landing-nav--scrolled' : ''}`}>
      <div className="landing-nav__inner">
        <Link to="/" className="landing-nav__logo">
          <svg
            className="landing-nav__logo-mark"
            width="30"
            height="30"
            viewBox="0 0 30 30"
            aria-hidden="true"
            focusable="false"
          >
            <circle cx="15" cy="15" r="15" fill="#0f172a" />
            <circle cx="15" cy="15" r="4.5" fill="#2563eb" />
          </svg>
          <span>Map of Projects</span>
        </Link>
        <div className="landing-nav__actions">
          <Link to={`/${PRIMARY_DEMO_ACCOUNT_ID}`} className="landing-nav__cta landing-nav__cta--secondary">
            Live Demo
          </Link>
          <Link to="/login" className="landing-nav__cta">
            Get Started Free
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default LandingNav;
